"use strict";
exports.__esModule = true;
var api_client_1 = require("../api_client");
var login_window_1 = require("./login_window");
var Auth = /** @class */ (function () {
    function Auth(apiClient, JWT, _a) {
        var authHost = _a.authHost, uid = _a.uid, authVersion = _a.authVersion;
        this.authClient = new api_client_1["default"]({
            JWTStorage: JWT,
            host: authHost,
            prefix: ''
        });
        this.authHost = authHost;
        this.authPrefix = "/auth/v" + authVersion;
        this.apiPrefix = "/api/v" + authVersion;
        this.uid = uid;
        this.apiClient = apiClient;
        this.JWT = JWT;
    }
    Auth.prototype.init = function () {
        return this.fetchJWT();
    };
    Auth.prototype.getUserId = function () {
        var payload = this.JWT.get().split('.')[1];
        return JSON.parse(atob(payload)).sub;
    };
    Auth.prototype.login = function (method) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!method) {
                reject('login method cannot be null');
                return;
            }
            var success = function (_a) {
                var jwt = _a.jwt, userInfo = _a.userInfo;
                _this.userInfo = userInfo;
                resolve({ jwt: jwt, userInfo: userInfo });
            };
            var url = _this.authClient.getApiUrl(_this.authPrefix + "/" + method + "?") + _this._userAgentInfo();
            var loginWindow = new login_window_1["default"](url, _this.authHost, success, reject);
        });
    };
    Auth.prototype.jwtAuth = function (provider, idToken) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.apiClient
                .post('/jwt_auth', {
                provider: provider,
                uid: _this.uid,
                id_token: idToken,
                source: 'aviasales',
                headers: [['Accept', 'application/json']]
            })
                .then(function (res) {
                if (res && res.jwt) {
                    _this.JWT.set(res.jwt);
                    _this.fetchUserInfo()
                        .then(function (_a) {
                        var userInfo = _a.userInfo;
                        resolve({ jwt: res.jwt, userInfo: userInfo });
                    })["catch"](reject);
                }
                else {
                    reject(res);
                }
            })["catch"](reject);
        });
    };
    Auth.prototype.logout = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.authClient["delete"](_this.apiPrefix + "/logout", {})
                .then(function () {
                _this.JWT.remove();
                _this.userInfo = null;
                resolve('ok');
            })["catch"](function (error) {
                reject(error);
            });
        });
    };
    Auth.prototype.fetchJWT = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var jwt = _this.JWT.get();
            if (!jwt) {
                var url = _this.apiPrefix + "/jwt?" + _this._userAgentInfo();
                _this.authClient
                    .get(url, {})
                    .then(function (data) {
                    if (data && data.jwt) {
                        resolve({ jwt: data.jwt });
                    }
                    else {
                        resolve({ jwt: null });
                    }
                })["catch"](function () {
                    resolve({ jwt: null });
                });
            }
            else {
                resolve({ jwt: jwt });
            }
        });
    };
    Auth.prototype._userAgentInfo = function () {
        return "uid=" + encodeURIComponent(this.uid) + "&redirect_uri=" + encodeURIComponent(window.location.href);
    };
    Auth.prototype.getUserInfo = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.userInfo) {
                resolve({ userInfo: _this.userInfo });
            }
            else {
                _this.fetchUserInfo()
                    .then(resolve)["catch"](reject);
            }
        });
    };
    Auth.prototype.fetchUserInfo = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!_this.JWT.get()) {
                reject('User is not authorized');
                return;
            }
            _this.apiClient
                .get('/user', {})
                .then(function (response) {
                _this.userInfo = response.user_info;
                resolve({ userInfo: _this.userInfo });
            })["catch"](reject);
        });
    };
    return Auth;
}());
exports["default"] = Auth;
